import React, { Component } from 'react';
import axios from 'axios';
import ReactQuill, { Quill } from 'react-quill';
import { withRouter } from './withRouter'; // adjust path if needed
import 'react-quill/dist/quill.snow.css';
import Sidebar from '../../Sidebar';

const Size = Quill.import('formats/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '24px', '32px'];
Quill.register(Size, true);


const COLORS = ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc'];

class HeadingFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageName: '',
      pageType: '',
      heading: '',
      description: '',
      meta_title: '',
      meta_description: '',
      pageTypes: ['Hero Section', 'Price Discovery', 'Features', 'Our Services', 'Pricing', 'FAQs', 'About', 'Footer'],
      isEdit: false,
      slug: '',
    };
  }

  componentDidMount() {
    const pageId = this.props.router?.params?.id;
    if (pageId) {
        this.fetchPage(pageId);
    }
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.router?.params?.id;
    const currentId = this.props.router?.params?.id;
  
    if (currentId && currentId !== prevId) {
      this.fetchPage(currentId);
    }
  }

  fetchPage = async (id) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/seo-pages/${id}`);
      const { pageName, pageType, heading, description, meta_title, meta_description, slug } = res.data;
      this.setState({
        pageName,
        pageType,
        heading,
        description,
        meta_title,
        meta_description,
        slug,
        isEdit: true,
      });
    } catch (err) {
      console.error('Error loading page:', err);
    }
  };

  generateSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.name === 'pageName') {
      const slug = this.generateSlug(e.target.value);
      this.setState({ slug });
    }
  };

  handleQuillChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { pageName, pageType, heading, description, meta_title, meta_description, slug, isEdit } = this.state;
    const data = { pageName, pageType, heading, description, meta_title, meta_description, slug };

    try {
      if (isEdit && this.props.router?.params?.id) {
        await axios.put(`${process.env.REACT_APP_API_URL}/admin/seo-pages/${this.props.router?.params?.id}`, data);
        alert('Page updated successfully');
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/admin/seo-pages`, data);
        alert('Page created successfully');
      }

      this.setState({
        pageName: '',
        pageType: '',
        heading: '',
        description: '',
        meta_title: '',
        meta_description: '',
        slug: '',
        isEdit: false,
      });

      this.props.router.navigate('/seo-pages');
    } catch (err) {
      console.error(err);
      alert('Error submitting form');
    }
  };

  render() {
    const { pageName, pageType, heading, description, meta_title, meta_description, pageTypes, slug } = this.state;

    const quillModules = {
      toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        [{ 'font': [] }, { 'size': Size.whitelist }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': COLORS }, { 'background': COLORS }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link', 'image'],
        ['clean']
      ]
    };

    const quillFormats = [
      'header', 'font', 'size',
      'bold', 'italic', 'underline', 'strike',
      'color', 'background',
      'list', 'bullet', 'link', 'image'
    ];

    return (
        <>
        
            <div className="sidebar">
            <Sidebar/>
            </div>
            <div id="tabler">
                <h2>{this.state.isEdit ? 'Edit Page' : 'Create Page'}</h2>
                <form onSubmit={this.handleSubmit}>
                <div>
                    <label>Page Name:</label>
                    <select name="pageName" value={pageName} onChange={this.handleInputChange} className='form-select'>
                    <option value="">-- Select Page --</option>
                    <option value="Home">Home</option>
                    <option value="Daily Commodity Prices">Daily Commodity Prices</option>
                    <option value="Crop Surveys">Crop Surveys</option>
                    <option value="Import & Exports Data">Import & Exports Data</option>
                    <option value="Cost of Production">Cost of Production</option>
                    <option value="Commodity Balance Sheets">Commodity Balance Sheets</option>
                    <option value="Historical Data">Historical Data</option>
                    <option value="Crop Advisory">Crop Advisory</option>
                    <option value="Custom Reports & Analysis">Custom Reports & Analysis</option>
                    <option value="Farmer Information">Farmer Information</option>
                    <option value="Water & Weather Data">Water & Weather Data</option>
                    <option value="REST API">REST API</option>
                    <option value="Cotton">Cotton</option>
                    <option value="Sugar">Sugar</option>
                    <option value="Wheat">Wheat</option>
                    <option value="Maize">Maize</option>
                    <option value="Rice">Rice</option>
                    <option value="Edible Oils">Edible Oils</option>
                    <option value="Pulses">Pulses</option>
                    <option value="Spices">Spices</option>
                    <option value="Other Commodities">Other Commodities</option>
                    <option value="News">News</option>
                    <option value="Blogs">Blogs</option>
                    <option value="About Us">About Us</option>
                    <option value="Pricing">Pricing</option>
                    <option value="Media">Media</option>
                    <option value="FAQs">FAQs</option>
                    <option value="Contact Us">Contact Us</option>
                    <option value="Terms and Conditions">Terms and Conditions</option>
                    <option value="Privacy Policy">Privacy Policy</option>
                    <option value="Cancellation and Refunds">Cancellation and Refunds</option>
                    </select>
                </div>
                <br />
                <div>
                  <label>Slug:</label>
                  <input type="text" name="slug" value={slug} className="form-control" readOnly />
                </div>
                <br />
                <div>
                    <label>Page Type:</label>
                    <select name="pageType" value={pageType} onChange={this.handleInputChange} className='form-select'>
                    <option value="">-- Select Type --</option>
                    {pageTypes.map((type, i) => (
                        <option key={i} value={type}>{type}</option>
                    ))}
                    </select>
                </div>
                <br />
                <div>
                    <label>Heading:</label>
                    <textarea
                        name="heading"
                        value={heading}
                        onChange={this.handleInputChange}
                        rows="3"
                        className="form-control"
                    ></textarea>
                </div>
                <br />
                <div>
                    <label>Description:</label>
                    <textarea
                        name="description"
                        value={description}
                        onChange={this.handleInputChange}
                        rows="8"
                        className="form-control"
                    ></textarea>
                </div>
                <br />
                <div>
                    <label>Meta Title:</label>
                    <textarea
                        name="meta_title"
                        value={meta_title}
                        onChange={this.handleInputChange}
                        rows="1"
                        className="form-control"
                    ></textarea>
                </div>
                <br />
                <div>
                    <label>Meta Description:</label>
                    <textarea
                        name="meta_description"
                        value={meta_description}
                        onChange={this.handleInputChange}
                        rows="8"
                        className="form-control"
                    ></textarea>
                </div>

                <button type="submit" style={{ marginTop: '20px', marginBottom: '20px' }} className="btn btn-lg btn-primary">
                    {this.state.isEdit ? 'Update' : 'Save'}
                </button>
                <button type="button" onClick={() => this.props.router.navigate('/seo-pages')} className="btn btn-lg btn-secondary" style={{ marginLeft: '10px' }}>
                    Cancel
                </button>
                </form>
            </div>
        </>
    );
  }
}

export default withRouter(HeadingFormComponent);
